import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from "@shared/services/common-data.service";

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent implements OnInit {
  @ViewChildren('stateTab')
stateTabs!: QueryList<ElementRef>;

  activeTab = 'north';
  liveMessage = '';
  data: any[] = [];
  activeTopicId = 0;
  url = '/karvy-branches';

  @ViewChildren('tabItem')
tabItems!: QueryList<ElementRef>;

tabs = ['north','south','east','west'];


  constructor(private apiService: ApiService,
    public router: Router,
    private commonDataService: CommonDataService) { }

  ngOnInit() {
    if (this.router.url === '/karvy-branches') {
      this.url = Urls.getKarvyBranches;
    } else if (this.router.url === '/amc-branches') {
      this.url = Urls.getAmcBranches;
      this.activeTab = 'west';
    } else {
      this.url = Urls.getYourAdvisor;
    }
    this.getData();
    this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  focusStateTab(index: number) {
  setTimeout(() => {
    this.stateTabs.get(index)?.nativeElement.focus();
  });
}

  getData = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(this.url, { region: this.activeTab }).subscribe(
      response => {
        this.data = response.data.finalList;
        this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  // setActive = (val: string) => {
  //   this.activeTab = val;
  //   this.activeTopicId = 0;
  //   this.getData();
  // }
  setActive = (val: string) => {
  this.activeTab = val;
  this.activeTopicId = 0;
  this.getData();

  this.liveMessage = '';

 setTimeout(() => {
  const region =
    val.charAt(0).toUpperCase() + val.slice(1);

  this.liveMessage =
    `${region} tab selected. ${this.data.length} states available.`;
}, 400);
}

  onHorizontalKeydown(event: KeyboardEvent,index:number){

  switch(event.key){

    case 'ArrowRight':
      event.preventDefault();
      this.moveTab(index+1);
      break;

    case 'ArrowLeft':
      event.preventDefault();
      this.moveTab(index-1);
      break;

    case 'Home':
      event.preventDefault();
      this.moveTab(0);
      break;

    case 'End':
      event.preventDefault();
      this.moveTab(this.tabs.length-1);
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActive(this.tabs[index]);
      break;
  }
}

onVerticalKeydown(event: KeyboardEvent, index: number) {

  let nextIndex = index;

  switch (event.key) {

    case 'ArrowDown':
      event.preventDefault();
      nextIndex = (index + 1) % this.data.length;
      break;

    case 'ArrowUp':
      event.preventDefault();
      nextIndex = (index - 1 + this.data.length) % this.data.length;
      break;

    case 'Home':
      event.preventDefault();
      nextIndex = 0;
      break;

    case 'End':
      event.preventDefault();
      nextIndex = this.data.length - 1;
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActiveState(index);
      return;

    default:
      return;
  }

  this.setActiveState(nextIndex);
  this.focusStateTab(nextIndex);
}

moveTab(index:number){

  if(index<0){
    index=this.tabs.length-1;
  }

  if(index>=this.tabs.length){
    index=0;
  }

  this.setActive(this.tabs[index]);

  setTimeout(()=>{
    this.tabItems.get(index)?.nativeElement.focus();
  });

}

  setActiveState = (id: number) => {
    this.activeTopicId = id;
  }

}
